import cn from 'classnames';
import { memo } from 'preact/compat';

import icons from './icons';

function camelToKebabCase(str) {
	return str
		.replace(/([\da-z])([A-Z])/g, '$1-$2')
		.replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
		.toLowerCase();
}

function Icon({ icon, className, label, ...restProps }) {
	if (!icons[icon]) {
		return null;
	}

	const IconComponent = icons[icon];

	return (
		<IconComponent
			label={label}
			className={cn(['ribbon-icon', `ribbon-icon__${camelToKebabCase(icon)}`], className)}
			{...restProps}
		/>
	);
}

export { camelToKebabCase, Icon };
export default memo(Icon);
